import { render, staticRenderFns } from "./CatalogHistoryModal.vue?vue&type=template&id=63558cd7&"
import script from "./CatalogHistoryModal.vue?vue&type=script&lang=js&"
export * from "./CatalogHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports